import React from 'react';
import ReactMarkdown from 'react-markdown';
import welcomeMarkdown from '../content/welcomeMarkdown';

const Welcome: React.FC = () => {
    return (
        <div className="welcome-container">
            <ReactMarkdown>{welcomeMarkdown}</ReactMarkdown>
        </div>
    );
};

export default Welcome;
